import { logger } from '../../../../utils/common/logger'
import { Store } from '../../../../utils/storage/keys'
import { LocalStore } from '../../../../utils/storage/local'
import { IProfile } from '../../../common/profile'

interface IWindow extends Window {
    Sailthru: {
        integration: (eventName: string, options: any) => {}
    }
}

declare let window: IWindow

export class NewsletterOptIn {
    public static DOM = {
        attrs: {
            newsletterMaybeLater: 'data-newsletter-maybe-later',
            newsletterSignup: 'data-newsletter-sign-up'
        },
        class: {
            pageNewsletterOptIn: 'page-newsletter-opt-in'
        }
    }

    public init() {
        const newsletterOptInPage = document.querySelector
            (`.${NewsletterOptIn.DOM.class.pageNewsletterOptIn}`)

        if (newsletterOptInPage) {
            const profile = LocalStore.get<IProfile>(Store.ID)
            const newsletterSignupButton =
                document.querySelector(`[${NewsletterOptIn.DOM.attrs.newsletterSignup}]`) as HTMLButtonElement
            const newsletterMaybeLaterButton =
                document.querySelector(`[${NewsletterOptIn.DOM.attrs.newsletterMaybeLater}]`) as HTMLButtonElement
            const email = (profile && profile.email) ? profile.email : undefined
            const redirect = (sessionStorage.getItem(Store.REDIRECT_URL)) ?
                sessionStorage.getItem(Store.REDIRECT_URL) : location.origin

            if (newsletterSignupButton) {
                newsletterSignupButton.addEventListener('click', () => {
                    const newsletterList =
                        newsletterSignupButton.getAttribute(NewsletterOptIn.DOM.attrs.newsletterSignup)
                    // Sailthru sign up
                    if (window.Sailthru) {
                        if (email) {
                            window.Sailthru.integration('userSignUp', {
                                email,
                                lists: {
                                    [newsletterList] : 1
                                },
                                onError: () => {
                                    logger('error', 'Unable to sign up for newsletter.')
                                },
                                onSuccess: () => {
                                    location.replace(redirect)
                                }
                            })
                        } else {
                            logger('error', 'User is not logged in')
                        }
                    }
                })
            }

            if (newsletterMaybeLaterButton) {
                newsletterMaybeLaterButton.addEventListener('click', () => {
                    location.replace(redirect)
                })
            }
        }
    }
}
